import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { ISecureStorage } from "../../classes/interfaces/isecurestorage";
import { withSpinner } from "../../extensions/withSpinner.extension";
import { UserAccessEnum } from "../../types";
import { API_ROOT, SECURE_SESSION_STORAGE } from "../../types/constants/appconstants";
import { User } from "../../types/user";

@Injectable({
    "providedIn": "root"
})
export class UserService {   
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private storage = inject<ISecureStorage>(SECURE_SESSION_STORAGE);
    private userServiceBaseUrl = this.apiRoot + "api/users";     
    private storageKey: string = "MyUserProfile";
    private roleStorageKey: string = "HelpId"
    
    getMyUserProfile(): Observable<User> {  
        var cacheUser = this.storage.getItem<User>(this.storageKey) as User;
        if(cacheUser) {
            const user$ = of(cacheUser);
            return user$;
        }

        const result$ = withSpinner(this.http, "Loading User Information...").get<User>(this.userServiceBaseUrl).pipe(
            tap((user: User) => {
                this.storage.setItem(this.storageKey, user);
                this.storage.setMD5Item(this.roleStorageKey, user.role.roleName);
            })
        );

        return result$;
    }

    getUserProfile(userGuid: string): Observable<User> {
        return withSpinner(this.http, "Loading User Information...").get<User>(this.userServiceBaseUrl + "/" + userGuid);
    }

    saveUser(user: User, actionType: UserAccessEnum): Observable<any> {
      return withSpinner(this.http).put(this.userServiceBaseUrl + "/" + user.azureGUID, { "user": user, "actionType": actionType }).pipe(
        tap(() => this.refreshMyUserProfile())
      );
    }

    searchUsers(firstName: string, lastName: string, userName: string, sourceKey: string): Observable<User[]> {
        return withSpinner(this.http).get<any[]>(this.userServiceBaseUrl + "/search?firstName=" + firstName + "&lastName=" + lastName + "&userName=" + userName + "&sourceKey=" + sourceKey);
    }

    private refreshMyUserProfile(): void {
        this.storage.removeItem(this.storageKey);
    }
}
